(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60629],{

/***/ 25549:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison/contact-us",
      function () {
        return __webpack_require__(67385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ContactUsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(30171);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/vpnpricecomparison/mainSection/index.tsx + 1 modules
var mainSection = __webpack_require__(80859);
// EXTERNAL MODULE: ./src/components/vpnpricecomparison/contactUs/contactUs.module.scss
var contactUs_module = __webpack_require__(60972);
var contactUs_module_default = /*#__PURE__*/__webpack_require__.n(contactUs_module);
// EXTERNAL MODULE: ./src/styles/variables/vpnpricecomparisonVariables.module.scss
var vpnpricecomparisonVariables_module = __webpack_require__(75735);
var vpnpricecomparisonVariables_module_default = /*#__PURE__*/__webpack_require__.n(vpnpricecomparisonVariables_module);
// EXTERNAL MODULE: ./src/components/shared/contactUs/contactUsForm.tsx + 3 modules
var contactUsForm = __webpack_require__(31750);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/contactUs/index.tsx





function ContactUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (contactUs_module_default())["contact-us"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center lg:w-2/5 mb-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col mb-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/messageIcon.svg",
                                    alt: "",
                                    className: "w-16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "font-medium text-xl mt-3 w-9/12",
                                    children: "Any Question or remarks? Just write us a message!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "w-9/12 font-light text-sm mt-2",
                                    children: "Fill up the form and our team will get back to you within 24 hours"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/mapIcon.svg",
                                    alt: "",
                                    className: "w-16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: (vpnpricecomparisonVariables_module_default()).melon
                                    },
                                    className: "mt-3 text-base ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/",
                                        children: "VpnPriceComparison.com"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-2",
                                    children: [
                                        "Dorrat khalda complex, Fourth floor ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Amman, Jordan, 11831"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-1",
                                    children: "P.O Box 217, ZipCode 11831"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-1",
                                    children: [
                                        "Phone:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-medium",
                                            children: "+962 (06) 2000 102 (Ext: 4866)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-1",
                                    children: [
                                        "Email:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:info@vpnpricecomparison.com",
                                            children: "info@vpnpricecomparison.com"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        backgroundColor: "white"
                    },
                    className: "w-fill lg:w-3/5 py-6 px-5 lg:p-6 rounded-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUsForm/* default */.Z, {
                        primaryColor: "#fe895c",
                        secondaryColor: "#161616",
                        classes: {
                            formClassName: (contactUs_module_default()).form,
                            fieldWrapperClassName: (contactUs_module_default())["field-wrapper"],
                            fieldClassName: (contactUs_module_default()).field
                        }
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/vpnpricecomparison/contact-us.tsx





var __N_SSP = true;
function ContactUsPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* VpnPriceComparisonWrapper */.S, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainSection/* default */.Z, {
                contactUs: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs, {})
        ]
    });
}


/***/ }),

/***/ 60972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","contact-us":"contactUs_contact-us__2V8g4","form":"contactUs_form__mT2JH","field-wrapper":"contactUs_field-wrapper__jkKLa","field":"contactUs_field__YWk_s"};

/***/ }),

/***/ 75735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5118,198,31750,30171,82546,74520,49774,92888,40179], function() { return __webpack_exec__(25549); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);